import React, { useEffect, useState } from "react";
import _ from "lodash";
import { useFetchEntityConfig } from "../redux/hooks";
import CustomDropdown from "components/CustomDropdown/CustomDropdown";

import TextWithTooltip from "components/Text/TextWithTooltip";
import { Box } from "@mui/material";

const TicketTypeLabel = ({ ticketType, edit, callback }) => {
  const [selectedTicketType, setSelectedTicketType] = useState(
    _.get(ticketType, "_id")
  );
  const { ticketTypeList } = useFetchEntityConfig();
  useEffect(async () => {
    setSelectedTicketType(_.get(ticketType, "_id"));
  }, [ticketType]);

  const renderTicketType = (v) => {
    return (
      <Box
        style={{
          background: "#F4EAFF",
          borderRadius: 2,
          padding: "4px 4px",
          display: "inline-block",
          height: "20px",
          maxWidth: "104px",
        }}
      >
        <TextWithTooltip
          style={{
            color: "#222",
            fontSize: 12,
            fontWeight: 500,
            lineHeight: "1.1",
          }}
          data={v}
          limitRows={1}
        />
      </Box>
    );
  };
  const typeName = _.get(ticketType, "name");

  if (edit) {
    return (
      <CustomDropdown
        border
        data={_.map(ticketTypeList, (o) => {
          return {
            label: o.name,
            value: o._id,
          };
        })}
        value={selectedTicketType}
        onSelect={(e) => {
          setSelectedTicketType(e.target.value);
          callback && callback(e.target.value);
        }}
      />
    );
  }
  if (!typeName) return <span />;
  return renderTicketType(typeName);
};

export default TicketTypeLabel;
